import { PtoEntriesTable } from "@/components/pto-entries/PtoEntriesTable";
import { PageHeader } from "@/components/shared/page-header";

export function EntriesPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="PTO Entries"
        description="Track your vacation, sick, and other time off."
      />
      <PtoEntriesTable />
    </div>
  );
}
